import { Box, Checkbox, TextField, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import UploadFile from "../../unit/UploadFile";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomApproved2CompletedFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record, actionType } = props;
  const applicationAccountInfo = record?.applicationAccountInfo;
  const [open, setOpen] = React.useState(false);
  const [showLoadingBtn, setShowLoadingBtn] = React.useState(false);
  const [appAutoRemoval, setAppAutoRemoval] = React.useState(
    record?.sAutoRemoval == "YES" ? "YES" : "NO"
  );
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-approved-completed"
        // label="Complete"
        label="To Loans"
        variant="contained"
        size="medium"
        color="success"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-approved-completed"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        // maxWidth="md"
        maxWidth={actionType == "ACH" ? "md" : "xs"}
        sx={{
          "& .MuiDialog-paper": {
            // minHeight: "40vh",
          },
        }}
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            setShowLoadingBtn(true);
            const reqUrl = `applications/actions/approved/email/notify`;
            const formData = new FormData(event.currentTarget);
            var uploadFileId = document.getElementById("uploadFileId") as any;
            if (uploadFileId) {
              formData.append("uploadFileIds", uploadFileId.value);
            }
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.methold = "NO";
            formJson.app_autoremoval = appAutoRemoval;
            formJson.link = "";
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Data saved successfully");
              if (props.cb) {
                props.cb("Funded");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
            setShowLoadingBtn(false);
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle
            record={record}
            subTitle="Notify Borrower Activate Loan"
          />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogApplicationBaseInfo appId={appId} record={record} />
            <DialogContentText>
              {record?.sSubType == "account" && (
                <>
                  <HeaderLabelTitle
                    title="Account has been funded. Notify applicant with account
                    documents."
                  />
                </>
              )}
              {record?.sSubType == "securedcreditcard" && (
                <>
                  <HeaderLabelTitle
                    title="Notify applicant and move application to LOCs/Credit Account
                    page."
                  />
                </>
              )}
              {/* repeat text, remove it for now */}
              {/* {record?.sSubType !== "account" &&
                record?.sSubType !== "securedcreditcard" && (
                  <>
                    <Typography>
                      Notify applicant and move application to Active Loans
                    </Typography>
                  </>
                )} */}
              {record?.delay_disbursement ? (
                <Typography variant="body1">
                  There was an unexpected delay of{" "}
                  <b>{record?.delay_disbursement}</b> days in disbursing the
                  funds.{" "}
                  <b>
                    A new loan payment schedule that takes into account for this
                    delay has been generated.
                  </b>
                </Typography>
              ) : (
                <></>
              )}
              {record?.sAutoRemoval == "YES" && (
                <Grid sx={{ mb: 2 }} container>
                  {/* <input
                    type="checkbox"
                    id="app_autoremoval"
                    style="margin-bottom: 0px;"
                  />
                  Remove applicant’s uploaded personal ID from system */}
                  <Grid item xs={2} sx={{ pt: 1 }}>
                    <Checkbox
                      name="app_autoremoval"
                      color="primary"
                      onChange={(e) => {
                        setAppAutoRemoval(e.target.checked ? "YES" : "NO");
                      }}
                    />
                  </Grid>
                  <Grid item xs={10} sx={{ pt: 2 }}>
                    Remove applicant’s uploaded personal ID from system
                  </Grid>
                </Grid>
              )}
              {/* removed it on 2026-02-12 comment, BB2-37 */}
              {/* {(actionType == "Finalize" || actionType != "ACH") && (
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle title="Upload Additional Documents If Any" />
                  </Grid>
                  <Grid item xs={5}>
                    <UploadFile
                      appId={appId}
                      uploadType="completefile"
                      uploadStep="Approved"
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              )} */}
              {actionType == "ACH" && (
                <>
                  <Grid sx={{ mb: 2 }} container>
                    <Grid item xs={12} sx={{ pt: 2 }}>
                      <Typography variant="body1">
                        Please confirm the account information for RECEIVING
                        loan payments.
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sx={{ mt: 1 }}>
                      Financial Institution Name
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        variant="outlined"
                        name="receiver_institution_name"
                        defaultValue={
                          applicationAccountInfo?.receiver_institution_name
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{ backgroundColor: "#f5f5f5" }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={5}>
                      Account Type
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        variant="outlined"
                        name="receiver_account_type"
                        defaultValue={
                          applicationAccountInfo?.receiver_account_type
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{ backgroundColor: "#f5f5f5" }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={5}>
                      Routing Number(9 number digit)
                    </Grid>
                    <Grid item xs={7}>
                      {/* {applicationAccountInfo?.receiver_routing_number} */}
                      <TextField
                        variant="outlined"
                        name="receiver_routing_number"
                        defaultValue={
                          applicationAccountInfo?.receiver_routing_number
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{ backgroundColor: "#f5f5f5" }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={5}>
                      Account Number
                    </Grid>
                    <Grid item xs={7}>
                      {/* {applicationAccountInfo?.receiver_account_number} */}
                      <TextField
                        variant="outlined"
                        name="receiver_account_number"
                        defaultValue={
                          applicationAccountInfo?.receiver_account_number
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{ backgroundColor: "#f5f5f5" }}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              <Typography variant="body1">
                Click "TO LOANS" button to remove this application from
                “Applications - Approved” page and create a new loan record. To
                upload a document, click “Uploaded Documents” icon on the right.
              </Typography>
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            sx={{ width: "auto" }}
            label={showLoadingBtn ? "Loading..." : "To Loans"}
            disabled={showLoadingBtn}
            color="success"
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
